import {Injectable} from '@angular/core';
import {Headers, Http, RequestOptions} from "@angular/http";

import 'rxjs/add/operator/toPromise';

export class Setting {

    public beforeVoteBoxHeading: string = 'Did you enjoy reading this article?';
    public beforeVoteBoxText: string = 'Your feedback will help us provide great articles and topics. Please take a second to vote down below.';

    public afterVoteBoxHeading: string = 'We appreciate your feedback!';
    public afterVoteBoxText: string = 'Thanks for helping us improve our articles.';

    public selectedVoteType: string = 'Rating (Smileys)';

    public backgroundColor: string = '#000';
    public headingColor: string = '#fff';
    public textColor: string = '#fff';

}

@Injectable()
export class SettingService {

    private apiUrl;

    private headers;

    constructor(private http: Http) {
        this.apiUrl = document.getElementById('wp-feedback-suite-container').dataset.apiUrl + 'feedback-suite/v1/';

        if (document.getElementById('wp-feedback-suite-container').dataset.apiNonce) {
            console.log('Nonce is present');

            this.headers = new Headers({
                'Content-Type': 'application/json',
                'X-WP-NONCE': document.getElementById('wp-feedback-suite-container').dataset.apiNonce
            });
        } else {
            console.log('Nonce is missing');
        }
    }

    getSetting(): Promise<Setting> {

        return this.http.get(this.apiUrl + 'settings', this.getOptions())
            .toPromise()
            .then(response => response.json() as Setting)
            .catch(this.handleError);
    }

    updateSetting(setting): Promise<Boolean> {

        return this.http.post(this.apiUrl + 'settings', JSON.stringify(setting), this.getOptions())
            .toPromise()
            .then()
            .catch(this.handleError)
    }

    deleteSetting(): Promise<Boolean> {

        return this.http.delete(this.apiUrl + 'settings', this.getOptions())
            .toPromise()
            .then(response => response.json() as Setting)
            .catch(this.handleError);
    }

    private getOptions() {
        return new RequestOptions({headers: this.headers});
    }

    private handleError(error: any): Promise<any> {
        console.error('An error occurred', error); // for demo purposes only
        return Promise.reject(error.message || error);
    }
}


// WEBPACK FOOTER //
// ./src/app/service/setting.service.ts